export default `
fragment LikeFragment on likes {
  likeableId: likeable_id,
  likeableType: likeable_type
  userId: user_id
}
`;
